import { triggerDrain } from './sync';

let attached = false;
let onlineHandler = null;
let visHandler = null;

export function attachSyncTriggers() {
  if (attached) return detachSyncTriggers;
  attached = true;
  onlineHandler = () => { triggerDrain(); };
  visHandler = () => {
    if (typeof document !== 'undefined' && document.visibilityState === 'visible') {
      triggerDrain();
    }
  };
  if (typeof window !== 'undefined') {
    window.addEventListener('online', onlineHandler);
  }
  if (typeof document !== 'undefined') {
    document.addEventListener('visibilitychange', visHandler);
  }
  return detachSyncTriggers;
}

export function detachSyncTriggers() {
  if (!attached) return;
  if (typeof window !== 'undefined' && onlineHandler) {
    window.removeEventListener('online', onlineHandler);
  }
  if (typeof document !== 'undefined' && visHandler) {
    document.removeEventListener('visibilitychange', visHandler);
  }
  attached = false;
  onlineHandler = null;
  visHandler = null;
}
